import * as React from 'react';

export type FnKey = 'F1' | 'F2' | 'F3' | 'F4' | 'F5' | 'F6' | 'F7' | 'F8' | 'F9' | 'F10' | 'F11' | 'F12';

export type ActionButtonDefinition = {
	title: string;
	image: string | SvgIcon;
	action: () => Promise<any>;
	functionKey?: FnKey;
};

type Props = {
	text: string;
	image: string | SvgIcon;
	onClick: () => void;
	hidden?: boolean;
	className?: string;
	functionKey?: FnKey;
};

export function isString(x: string | SvgIcon): x is string {
	return Object.prototype.toString.call(x) === '[object String]';
}

export function ActionButton({ text, image, onClick, hidden, className, functionKey }: Props) {

	const style: React.CSSProperties = hidden ? { visibility: 'hidden' } : { textAlign: 'center' };

	// React interpreta los componentes en minúscula como etiquetas html, si quiero renderizar un
	// componente el nombre tiene que ir en mayúscula, si no React se enfada mucho
	const Icon = image;

	return <a className={`btn btn-default btn-action ${className ? className : ''}`} style={style} onClick={onClick}>
		{functionKey
			? <span style={{ textAlign: 'right', opacity: .8, fontSize: 9, position: 'absolute', width: '100%', left: '-4px' }}>{functionKey}</span>
			: null
		}
		{isString(image)
			? (image ? <img src={image} style={{ opacity: image ? 1 : 0 }} /> : null)
			: <Icon />
		}
		<span>{text}</span>
	</a>;
}

export type Executor<T> = (args: {
	waitForPendingRequests?: boolean,
	overlay?: 'on-start' | 'on-first-request'
	action: () => Promise<T>
}) => Promise<T>;


export function wrapAction(executor: Executor<any>, btnDefinition: ActionButtonDefinition) {
	return () => executor({
		// Bloqueo desde el principio la pantalla. Como el overlay tarda un tiempo ser visible, si todo el proceso
		// es local y se ejecuta rápidamente, no se llega a ver y no hay parpadeos raros.
		overlay: 'on-start',
		waitForPendingRequests: true,
		action: async () => {
			if (btnDefinition)
				await btnDefinition.action();
		}
	});
}

export function addPreconditionButtons(executor: Executor<any>, actionButtons: Nullable<ActionButtonDefinition>[]) {
	return actionButtons.map((btnDefinition, idx) => {

		const action = btnDefinition ? wrapAction(executor, btnDefinition) : () => { };

		return btnDefinition === null
			? <ActionButton key={idx} text={''} image={''} onClick={() => { }} hidden />
			: <ActionButton key={idx} text={btnDefinition.title} image={btnDefinition.image} onClick={action} functionKey={btnDefinition.functionKey} />;
	});
}